import React, { Component } from 'react';
import { connect } from 'dva';
import { parse } from 'qs';
import { Tabs } from 'antd';
import Container from '../../../../../components/Container';
import SubDeptartmentForm from '../companents/SubDeptartmentForm/index';
import DeptRole from './Role';
import DeptMember from './Member';
import styles from './index.less';

const { TabPane } = Tabs;

@connect(({ subDept }) => {
  return {
    ...subDept,
  };
})
class SubDept extends Component {
  constructor(props) {
    super(props);

    const params = parse(window.location.search.split('?').pop());

    this.currentDeptId = params.currentDeptId;
    this.currentDeptName = params.currentDeptName;

    this.handleTabsChange = this.handleTabsChange.bind(this);

    this.state = {
      // tab
      tabData: [
        {
          tabName: '下级部门',
          tabKey: 'sub_Dept',
          tabIndex: 0,
        },
        {
          tabName: '部门岗位',
          tabKey: 'dept_role',
          tabIndex: 1,
        },
        {
          tabName: '部门成员',
          tabKey: 'dept_menber',
          tabIndex: 2,
        },
      ],
      currentTabKey: params.tabKey || 'sub_Dept', // 当前的tab的key值
    };
  }

  componentWillReceiveProps() {
    const params = parse(window.location.search.split('?').pop());
    const { currentTabKey } = this.state;

    if (params.tabKey !== currentTabKey) {
      this.setState({
        currentTabKey: params.tabKey || 'sub_Dept',
      });
    }
  }

  // tab切换
  handleTabsChange(key) {
    const { currentTabKey } = this.state;
    const { dispatch } = this.props;
    if (currentTabKey !== key) {
      dispatch({
        type: 'deptMember/reset',
      });
      this.setState({
        currentTabKey: key,
      });
    }
  }

  render() {
    const { tabData, currentTabKey } = this.state || {};
    const { breadcrumb, isUpdate = false } = this.props || {};

    return (
      <Container breStates isBreVersion breDataSource={breadcrumb}>
        <div className={styles.root}>
          <Tabs onChange={this.handleTabsChange} type="card" activeKey={currentTabKey}>
            {tabData.map(({ tabName, tabKey }) => (
              <TabPane tab={tabName} key={tabKey} />
            ))}
          </Tabs>

          <div className="sub-dept-content">
            {!isUpdate && currentTabKey === 'sub_Dept' && <SubDeptartmentForm type={2} />}
            {currentTabKey === 'dept_role' && <DeptRole />}
            {currentTabKey === 'dept_menber' && <DeptMember />}
          </div>
        </div>
      </Container>
    );
  }
}
export default SubDept;
